import { Provider } from '@angular/core'

import { ENVIRONMENT } from '@yoshu-lib/core/tokens/environment.token'

import { environment } from '@teknor/env/environment'

/**
 * Provides the environment configuration for the application.
 *
 * This function returns a provider object that binds the `ENVIRONMENT` token
 * to the `environment` value, allowing it to be injected throughout the application.
 *
 * @returns {Provider} A provider object for the environment configuration.
 */
export const provideEnvironment = (): Provider => {
  return { provide: ENVIRONMENT, useValue: environment }
}
